export default (value, prop) => {
    const what = String(value).toLowerCase();

    return (item) => String(item[prop]).toLowerCase() === what;
};
